import { makeStyles, Theme, createStyles } from '@material-ui/core';
import React, { FC } from 'react';
import { ContactInfoSectionData } from '../ContactsPage.types';
import ContactInfo from './ContactInfo';

export type ContactInfoSectionProps = {
  data: ContactInfoSectionData;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    title: {
      fontWeight: 600,
      fontSize: '2rem',
      margin: 0,
    },
    items: {
      display: 'flex',
      rowGap: '2rem',
      columnGap: '4rem',
      flexWrap: 'wrap',
    },
  }),
);

const ContactInfoSection: FC<ContactInfoSectionProps> = ({ data }) => {
  const classes = useStyles();

  return (
    <section className={classes.root}>
      <h3 className={classes.title}>{data.title}</h3>
      <div className={classes.items}>
        {data.items?.map((item, index) => (
          <ContactInfo data={item} key={index} />
        ))}
      </div>
    </section>
  );
};

export default ContactInfoSection;
